import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on SCHEDULES
  fetchSchedules: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchSchedules';

    commit(`${mutationPrefix}Pending`);

    return api.fetchSchedules(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on SCHEDULES
  fetchSchedule: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchSchedule';

    commit(`${mutationPrefix}Pending`);

    return api.fetchSchedule(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on SCHEDULES
  createSchedule: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createSchedule';

    commit(`${mutationPrefix}Pending`);

    return api.createSchedule(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on SCHEDULES
  updateSchedule: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateSchedule';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateSchedule(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on SCHEDULES
  deleteSchedule: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deleteSchedule';

    commit(`${mutationPrefix}Pending`, id);

    return api.deleteSchedule(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  setContext: ({ commit }, payload = null) => {
    commit('setContext', payload);
  },

  openFormModal: ({ commit }, payload = null) => {
    commit('openFormModal', payload);
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/schedule/actions.js